<template>
  <v-container fluid>
    <v-card class="mx-auto" max-width="800">
      <v-card-title class="primary white--text v-card-title">
        Promoción
      </v-card-title>
      
      <v-card-text class="pt-6">
        <v-form ref="form" v-model="validForm" lazy-validation>
          <v-row>
            <!-- Folio -->
            <v-col cols="12" sm="6">
              <v-text-field
                v-model="promocion.folio"
                label="Folio"
                outlined
                required
                :rules="[rules.required]"
                prepend-inner-icon="receipt"
              ></v-text-field>
            </v-col>
            
            <!-- Nombre del Paciente -->
            <v-col cols="12" sm="6">
              <v-text-field
                v-model="promocion.nombrePaciente"
                label="Nombre del Paciente"
                outlined
                required
                :rules="[rules.required]"
                prepend-inner-icon="person"
              ></v-text-field>
            </v-col>
            
            <!-- Fecha de Pago -->
            <v-col cols="12" sm="4">
              <v-menu
                ref="menuFechaPago"
                v-model="menuFechaPago"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="promocion.fechaPagoFormated"
                    label="Fecha de Solicitud"
                    prepend-icon="event"
                    readonly
                    outlined
                    :rules="[rules.required]"
                    v-bind="attrs"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="promocion.fechaPago"
                  @input="menuFechaPago = false"
                  locale="es-es"
                  no-title
                  :max="getTodayDate()"
                ></v-date-picker>
              </v-menu>
            </v-col>
            
            <!-- Fecha de Toma -->
            <v-col cols="12" sm="4">
              <v-menu
                ref="menuFechaToma"
                v-model="menuFechaToma"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="promocion.fechaTomaFormated"
                    label="Fecha de Cita"
                    prepend-icon="event"
                    readonly
                    outlined
                    :rules="[rules.required]"
                    v-bind="attrs"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="promocion.fechaToma"
                  @input="menuFechaToma = false"
                  locale="es-es"
                  no-title
                  :max="getTodayDate()"
                ></v-date-picker>
              </v-menu>
            </v-col>
            
            <!-- Fecha de Recepción -->
            <v-col cols="12" sm="4">
              <v-menu
                ref="menuFechaRecepcion"
                v-model="menuFechaRecepcion"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="promocion.fechaRecepcionFormated"
                    label="Fecha de Recepción"
                    prepend-icon="event"
                    readonly
                    outlined
                    :rules="[rules.required]"
                    v-bind="attrs"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="promocion.fechaRecepcion"
                  @input="menuFechaRecepcion = false"
                  locale="es-es"
                  no-title
                  :max="getTodayDate()"
                ></v-date-picker>
              </v-menu>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
      
      <v-card-actions class="px-6 pb-6">
        <v-spacer></v-spacer>
        <v-btn
          color="secondary"
          text
          @click="limpiarFormulario"
        >
          <v-icon left>clear</v-icon>
          Limpiar
        </v-btn>
        <v-btn
          color="primary"
          :disabled="!validForm"
          @click="guardarPromocion"
          style="background-color: #21436A;"
        >
          <v-icon left>save</v-icon>
          Guardar
        </v-btn>
      </v-card-actions>
    </v-card>
    
    <!-- Snackbar para mensajes -->
    <v-snackbar
      v-model="snackbar.show"
      :color="snackbar.color"
      :timeout="snackbar.timeout"
      top
    >
      {{ snackbar.text }}
      <v-btn
        text
        @click="snackbar.show = false"
      >
        Cerrar
      </v-btn>
    </v-snackbar>
  </v-container>
</template>

<script>
export default {
  name: 'Promocion',
  data() {
    return {
      validForm: false,
      menuFechaPago: false,
      menuFechaToma: false,
      menuFechaRecepcion: false,
      promocion: {
        folio: '',
        nombrePaciente: '',
        fechaPago: null,
        fechaToma: null,
        fechaRecepcion: null,
        fechaPagoFormated: '',
        fechaTomaFormated: '',
        fechaRecepcionFormated: ''
      },
      rules: {
        required: value => !!value || 'Este campo es requerido'
      },
      snackbar: {
        show: false,
        text: '',
        color: 'success',
        timeout: 3000
      }
    };
  },
  watch: {
    'promocion.fechaPago'(newVal) {
      if (newVal) {
        this.promocion.fechaPagoFormated = this.formatDate(newVal);
      }
    },
    'promocion.fechaToma'(newVal) {
      if (newVal) {
        this.promocion.fechaTomaFormated = this.formatDate(newVal);
      }
    },
    'promocion.fechaRecepcion'(newVal) {
      if (newVal) {
        this.promocion.fechaRecepcionFormated = this.formatDate(newVal);
      }
    }
  },
  methods: {
    formatDate(date) {
      if (!date) return null;
      
      const [year, month, day] = date.split('-');
      return `${day}/${month}/${year}`;
    },
    
    getTodayDate() {
      const today = new Date();
      const year = today.getFullYear();
      const month = String(today.getMonth() + 1).padStart(2, '0');
      const day = String(today.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    },
    
    initializeDates() {
      const today = this.getTodayDate();
      this.promocion.fechaPago = today;
      this.promocion.fechaToma = today;
      this.promocion.fechaRecepcion = today;
      this.promocion.fechaPagoFormated = this.formatDate(today);
      this.promocion.fechaTomaFormated = this.formatDate(today);
      this.promocion.fechaRecepcionFormated = this.formatDate(today);
    },
    
    limpiarFormulario() {
      this.$refs.form.reset();
      this.promocion.folio = '';
      this.promocion.nombrePaciente = '';
      // Restablecer fechas a hoy
      this.initializeDates();
    },
    
    async guardarPromocion() {
      if (this.$refs.form.validate()) {
        try {
          // Aquí iría la llamada a la API para guardar la promoción
          console.log('Guardando promoción:', this.promocion);
          
          // Simular guardado exitoso
          this.mostrarMensaje('Promoción guardada exitosamente', 'success');
          
          // Limpiar solo los campos de texto, mantener fechas
          setTimeout(() => {
            this.promocion.folio = '';
            this.promocion.nombrePaciente = '';
            this.$refs.form.resetValidation();
          }, 1000);
          
        } catch (error) {
          console.error('Error al guardar promoción:', error);
          this.mostrarMensaje('Error al guardar la promoción', 'error');
        }
      }
    },
    
    mostrarMensaje(texto, color = 'success') {
      this.snackbar.text = texto;
      this.snackbar.color = color;
      this.snackbar.show = true;
    }
  },
  
  mounted() {
    // Inicializar fechas con la fecha actual
    this.initializeDates();
    console.log('Pantalla Promoción cargada');
  }
};
</script>

<style scoped>
.v-card-title {
  font-size: 1.05rem;
  font-weight: 500;
  background-color: #002855 !important;
}

.v-card-text {
  background-color: #fafafa;
}

/* Aplicar color primario consistente */
.theme--light.v-btn.v-btn--has-bg.primary {
  background-color: #002855 !important;
  border-color: #002855 !important;
}

/* Color hover para botones primarios */
.theme--light.v-btn.v-btn--has-bg.primary:hover {
  background-color: #003a75 !important;
}

/* Asegurar que el color se aplique a elementos primary */
.primary {
  background-color: #21436A !important;
}
</style>